import { render, staticRenderFns } from "./CoaOilShxto.vue?vue&type=template&id=36a88bf4&scoped=true&"
import script from "./CoaOilShxto.vue?vue&type=script&lang=js&"
export * from "./CoaOilShxto.vue?vue&type=script&lang=js&"
import style0 from "./CoaOilShxto.vue?vue&type=style&index=0&id=36a88bf4&prod&lang=scss&scoped=true&"
import style1 from "./CoaOilShxto.vue?vue&type=style&index=1&id=36a88bf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a88bf4",
  null
  
)

export default component.exports